import { Flex } from '@backstage/ui';
import { makeStyles } from '@material-ui/core';
import { TagChip } from './TagChip';

const useStyles = makeStyles(() => ({
  container: {
    flexWrap: 'wrap',
  },
}));

type TagsProps = {
  tags: string[];
  filter: string[];
  onUpdate: (tags: string[]) => void;
};

export const Tags = ({ tags, filter, onUpdate }: TagsProps) => {
  const classes = useStyles();

  const updateFilter = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const selected = (event.target as HTMLDivElement).innerText;
    const isSelected = filter.includes(selected);
    const updated = isSelected ? filter.filter(c => c !== selected) : [...filter, selected];
    onUpdate(updated);
  };

  const chips = tags
    ?.toSorted()
    .map((tag: string) => (
      <TagChip
        key={tag}
        variant={filter.indexOf(tag) !== -1 ? 'default' : 'outlined'}
        color="primary"
        label={tag}
        onClick={updateFilter}
      />
    ));
  return (
    <Flex gap="var(--bui-space-2)" className={classes.container} data-calendar-element="tags">
      {chips}
    </Flex>
  );
};
